import * as Types from '../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
export type PlayChromecastContentPlaybackTokenQueryVariables = Types.Exact<{
  guid: Types.Scalars['String']['input'];
  format: Array<Types.InputMaybe<Types.Format>> | Types.InputMaybe<Types.Format>;
  drm: Array<Types.InputMaybe<Types.Drm>> | Types.InputMaybe<Types.Drm>;
  lar?: Types.InputMaybe<Array<Types.InputMaybe<Types.Lar>> | Types.InputMaybe<Types.Lar>>;
  codec?: Types.InputMaybe<Array<Types.InputMaybe<Types.Codec>> | Types.InputMaybe<Types.Codec>>;
  resolution?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
    | Types.InputMaybe<Types.Scalars['String']['input']>
  >;
  dynamicRange?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.DynamicRange>> | Types.InputMaybe<Types.DynamicRange>
  >;
  maxBPS?: Types.InputMaybe<Array<Types.InputMaybe<Types.MaxBps>> | Types.InputMaybe<Types.MaxBps>>;
}>;

export type PlayChromecastContentPlaybackTokenQuery = {
  drmLicense: { __typename: 'DrmLicense'; drm: Types.Drm; url: string; token: string } | null;
};

export const PlayChromecastContentPlaybackToken = gql`
  query play_chromecast_content_Playback_token(
    $guid: String!
    $format: [Format]!
    $drm: [Drm]!
    $lar: [Lar]
    $codec: [Codec]
    $resolution: [String]
    $dynamicRange: [DynamicRange]
    $maxBPS: [MaxBPS]
  ) {
    drmLicense(
      guid: $guid
      capabilities: {
        format: $format
        drm: $drm
        lar: $lar
        codec: $codec
        resolution: $resolution
        dynamicRange: $dynamicRange
        maxBPS: $maxBPS
      }
    ) {
      drm
      url
      token
    }
  }
`;
